import {ReactNode} from "react";
import {Box} from "@mui/joy";
import {Navbar} from "../pages/Navbar";
import {Footer} from "./Footer";

interface LayoutProps {
    children: ReactNode;
}

// Involucro comune a tutte le pagine: navbar sticky (non più `position:
// fixed` a piena larghezza) + contenuto + footer sempre in fondo (sticky
// footer pattern: `minHeight:'100vh'` + flex column, così il footer resta
// in fondo anche su pagine con poco contenuto, e scende naturalmente su
// pagine più lunghe invece di sovrapporsi).
export function Layout({children}: LayoutProps) {
    return (
        <Box sx={{minHeight: "100vh", display: "flex", flexDirection: "column"}}>
            <Navbar />
            <Box sx={{flex: "1 0 auto", display: "flex", flexDirection: "column"}}>
                {children}
            </Box>
            <Footer />
        </Box>
    );
}
